import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const AirplaneOutlineIcon = ({
  title = 'Airplane Outline',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} {...props}>
    {/* prettier-ignore */}
    <path d="m13.03 25.609-5.4968 2.9182v-1.9917l2.8485-2.9689v-7.0538l-9.9295 3.8672v-1.9227l9.981-7.2204v-7.4903s0.0019-0.84173 0.4864-1.5667c0.361-0.54007 0.9897-1.0153 2.085-1.0296 0.0085-3.3e-4 0.017-3e-4 0.0254-2.5e-4 0.0085-5e-5 0.017-8e-5 0.0254-8e-5 1.0954 0.01459 1.7241 0.48986 2.0851 1.0299 0.4845 0.72498 0.4864 1.5667 0.4864 1.5667v7.4903l9.981 7.2204v1.9227l-9.9295-3.8672v7.0538l2.8485 2.9689v1.9917l-5.4969-2.9182z" clipRule="evenodd" fillRule="evenodd" stroke="currentColor" strokeLinejoin="round" strokeWidth=".52147" />
  </CreateIconComponent>
);

export default AirplaneOutlineIcon;
